import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'
import type { ComponentChildren } from 'preact'
import { useState } from 'preact/hooks'
import type { ShiftFields } from '../api/generated/ShiftFields'
import { useAction } from '../api/useAction'
import { fromInput, toInput } from './time'

const inputValue = (e: Event) => (e.target as HTMLInputElement).value
const shrink = { inputLabel: { shrink: true } }

/** Times are typed and shown in the event's local time; `children` are extra fields shown first. */
export function ShiftDialog({
  title,
  initial,
  onSubmit,
  onClose,
  children,
}: {
  title: string
  initial: ShiftFields
  onSubmit: (fields: ShiftFields) => Promise<void>
  onClose: () => void
  children?: ComponentChildren
}) {
  const [startsAt, setStartsAt] = useState(toInput(initial.starts_at))
  const [endsAt, setEndsAt] = useState(toInput(initial.ends_at))
  const [required, setRequired] = useState(String(initial.required_volunteers))
  const { error, pending, run } = useAction()
  const submit = (e: Event) => {
    e.preventDefault()
    run(() =>
      onSubmit({
        starts_at: fromInput(startsAt),
        ends_at: fromInput(endsAt),
        required_volunteers: Number(required),
      }),
    )
  }
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={submit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            {children}
            <TextField
              label="Début"
              type="datetime-local"
              required
              slotProps={shrink}
              value={startsAt}
              onInput={(e) => setStartsAt(inputValue(e))}
            />
            <TextField
              label="Fin"
              type="datetime-local"
              required
              slotProps={{ ...shrink, htmlInput: { min: startsAt } }}
              value={endsAt}
              onInput={(e) => setEndsAt(inputValue(e))}
            />
            <TextField
              label="Bénévoles requis"
              type="number"
              required
              slotProps={{ htmlInput: { min: 1, max: 1000 } }}
              value={required}
              onInput={(e) => setRequired(inputValue(e))}
            />
            {error && <Alert severity="error">{error}</Alert>}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Annuler</Button>
          <Button type="submit" variant="contained" loading={pending}>
            Enregistrer
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
